'use client';

import { type CarouselApi } from '@repo/ui/carousel';
import { cn } from '@repo/utils/cn';
import { useLocale, useTranslations } from 'next-intl';
import ScrollableTabItems from '@/components/common/scrollable-tab-items';
import { usePathname } from '@/i18n/routing';
import type { GameCategoryResponseType } from '@/lib/fetch';
import { type GamesCategoryItem, getGamesCategoryItems } from '@/lib/utils/casino-categories';

interface GamesCategoryFilterProps {
  staticCategory?: string;
  data: GameCategoryResponseType;
  onClick?: (item: GamesCategoryItem, api: CarouselApi, index: number) => void;
  pathnameReplacement?: string;
  className?: string;
}

const GamesCategoryFilter = ({
  staticCategory,
  data,
  pathnameReplacement,
  className,
  onClick,
}: GamesCategoryFilterProps) => {
  const t = useTranslations('casino');
  const locale = useLocale();

  const pathname = usePathname();

  const gamesCategories = getGamesCategoryItems(t, data, locale, staticCategory);

  return (
    <ScrollableTabItems
      testId="game-categories-navigation-bar"
      data={gamesCategories}
      className={cn('vt-surface-darker-bg rtl:pr-2', className)}
      pathname={pathnameReplacement || (pathname === '/casino' ? '/casino/lobby' : pathname)}
      variant="border"
      orientation="horizontal"
      onClick={onClick}
    />
  );
};

export default GamesCategoryFilter;
